import React, { Component, createContext, useContext } from 'react'
import { get, post } from 'api'
import PubSub from 'pubsub-js'

const AbsenceAdjustmentsContext = createContext()
AbsenceAdjustmentsContext.displayName = 'AbsenceAdjustments'

export default class AbsenceAdjustmentsProvider extends Component {
    constructor(props) {
        super(props)

        !!props?.userId && this.setUserId(props.userId, false)

        this.fetchController = new AbortController()

        this.state = {
            adjustments: [],

            fetchAdjustments: this.fetch,
            setUserId: this.setUserId,

            makeAdjustment: this.makeAdjustment,

            fetching: false,
            hasFetched: false
        }

        this.refreshSubscription = PubSub.subscribe('absenceAdjustments.refresh', () => {
            this.setState({
                adjustments: [],
                hasFetched: false
            }, this.fetch)
        })
    }

    componentDidMount() {
        this.fetch()
    }

    componentDidUpdate({ userId }) {
        const userIdChanged = userId !== this.props.userId

        if(userIdChanged) {
            this.setUserId(this.props.userId, false)

            this.fetch(true)
        }
    }

    componentWillUnmount() {
        this.fetchController.abort()
        PubSub.unsubscribe(this.refreshSubscription)
    }

    fetch = async (force = false) => {
        const {
            fetching,
            hasFetched
        } = this.state

        if(!this.userId || fetching || (!force && hasFetched)) {
            return
        }

        if(force || fetching) {
            this.fetchController.abort()
            this.fetchController = new AbortController()
        }

        const { ok, response: adjustments } = await get({
            path: `/absence/adjustments/${this.userId}`
        })

        if(ok && adjustments) {
            this.setState({
                adjustments,
                hasFetched: true,
                fetching: false
            })
        } else {
            this.setState({
                hasFetched: true,
                fetching: false
            })
        }

        return { ok, response: adjustments }
    }

    makeAdjustment = async body => {
        const { ok, response } = await post({
            path: `/absence/adjustments/${this.userId}`,
            body
        })

        return { ok, response }
    }

    setUserId = (id, fetch = true) => {
        this.userId = id
        fetch && this.fetch(true)

        !id && this.setState({ adjustments: [] })
    }

    render() {
        const { children = null } = this.props

        return (
            <AbsenceAdjustmentsContext.Provider value={this.state}>
                {(typeof children === 'function') && children(this.state)}
                {(typeof children !== 'function') && children}
            </AbsenceAdjustmentsContext.Provider>
        )
    }
}

export const useAbsenceAdjustments = () => useContext(AbsenceAdjustmentsContext)
